export default {
    common: {
        documentTitle: "Dailyedu - for Student",
        close: "Close",
        confirm: 'Confirm',
        cancel: "Cancel",
        cancelApp: "Cancel",
        changetime: 'Change time',
        login: "Login",
        submit: "Submit",
        nodata: "Xiaozhi has not found any data yet",
        noSession: "No Message",
        noTime: "No available time slots ",
        return: "Return",
        logout: "Log out",
        giveup: "Quit",
        iSee: "OK",
        refreshSuc: "Refreshed",
        clearSuc: "Cleared",
        settingSuc: "Setting complete",
        finish: "Done",
        other: "Others",
        index: "Daily Edu",
        titleTips: "Tips",
        nothing: "No score",
        noDevelop: "Not yet developed",
        shareTips: "Please click on the top right corner to share",
        daienEducation: "Daily Edu.",
        and: ",",
        ended: ".",
        dollar: "yuan",
        download: "Download",
        goConfirm: "To Confirm",
        noMore: "No More data",
        loading: "loading...",
        bind: 'Bind',
        jumpHint: "Going to Daily AI Drill mini program from APP？",
        jumpHint1: "Redirecting to contests mini-app…",
        newJ: "Automatically load when new messages received",
        jxjcancel: "Canceled. The scholarship used has been returned to the account. ",
        dd: "more",
        Reelection: "Reselect",
        copy: "Copy",
        copied: "Copied",
        copyFailed: "Copy failed"
    },
    queryOralUser: {
        title: "请输入名称",
        cx: "查询",
        project: "请输入项目名称",
        teacher: "请输入姓名/昵称/地区",
        examPublish: '请输入考试名称'
    },
    daiEnStudent: {
        title: "请输入手机号/姓名",
    }
}


// WEBPACK FOOTER //
// ./src/lang/en.js